import { TicketSharedWithClientProfileType } from './TicketSharedWithClientProfile.enum';
import type { ITicketSharedWithClientProfileSection } from './TicketSharedWithClientProfileSection.interface';

export default class TicketSharedWithClientProfileSection
  implements ITicketSharedWithClientProfileSection {
  section: TicketSharedWithClientProfileType;
  isCompleted: boolean;

  static build = (data: ITicketSharedWithClientProfileSection) =>
    new TicketSharedWithClientProfileSection(data);

  static blank = () => new TicketSharedWithClientProfileSection();

  /**
   * Constructor
   * @param {TicketSharedWithClientProfileSection} data
   */
  constructor(data?: ITicketSharedWithClientProfileSection) {
    this.section = TicketSharedWithClientProfileType.of(data?.section?.name);
    this.isCompleted = data?.isCompleted === true;
  }
}
